import React from 'react';
import { motion } from "framer-motion";
import { Check } from "lucide-react";

const ThankYou = () => {
  return (
    // 1. Changed background to white (bg-white) and default text to black
    <div className="min-h-screen flex items-center justify-center bg-white px-6 text-black">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        // 2. Box changes:
        // - max-w-md for medium size
        // - Removed dark bg/borders. Added transparent bg, blur, subtle gray border, and shadow for glassy effect on white.
        // - Adjusted padding slightly for better proportions on medium size.
        className="relative max-w-md w-full text-center bg-transparent backdrop-blur-xl border border-gray-200 shadow-sm rounded-3xl px-8 py-12 md:px-10 md:py-16"
      >
        {/* Removed the "Soft Edge Glow" div as it is not needed on a white background glass effect */}

        {/* Tick Container */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 140 }}
          // 3. Circle changes: "filled with glass light green" (bg-green-100/80) and "border as nrml light green" (border-green-500)
          className="mx-auto mb-8 flex items-center justify-center w-20 h-20 rounded-full bg-green-100/80 border border-green-500"
        >
          {/* 4. Icon change: "professional light green" */}
          <Check size={38} className="text-green-600" />
        </motion.div>

        {/* Title */}
        {/* 5. Text ensured black */}
        <h1 className="text-4xl font-bold mb-4 text-black">
          Thank You
        </h1>

        {/* Message */}
        {/* 6. Text changed to a softer black (gray-700) for professional look on white */}
        <p className="text-gray-700 text-lg leading-relaxed mb-10">
          Your submission was successful.
          <br />
          We will review your details and respond shortly.
        </p>

        {/* Button */}
        <a
          href="/"
          // 7. Button changed to green to match the theme and pop against white bg.
          className="inline-block px-8 py-4 rounded-xl bg-green-600 text-white font-semibold hover:scale-[1.03] hover:bg-green-700 transition-all"
        >
          Back to Home
        </a>
      </motion.div>
    </div>
  );
};

export default ThankYou;